<template>
    <transition name="slide">
        <div v-show="getVisibilityAppBar" class="appbar">
            <div class="appbar-items-wrapper">
                <router-link :to="{ name: 'Landing' }" exact>Home</router-link>
                <router-link :to="{ name: 'Profile' }">Profile</router-link>
                <router-link :to="{ name: 'Projects' }">Projects</router-link>
                <router-link :to="{ name: 'Contact' }" exact>Contact</router-link>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'AppBar',
    data() {
        return {
            lastScrollPosition: 0
        }
    },
    computed: {
        ...mapGetters(['getVisibilityAppBar'])
    },
    methods: {
        ...mapActions(['showMenu', 'hideMenu']),
        // onScroll() {
        //     // Get the current scroll position
        //     // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
        //     const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop 
        //     if (currentScrollPosition < 0) {
        //         this.hideMenu();
        //         return
        //     }

        //     if (currentScrollPosition > 10) {
        //         this.showMenu();
        //     }
        //     else {
        //         this.hideMenu();
        //     }
        // }
    },
    // mounted () {
    //     window.addEventListener('scroll', this.onScroll);
    // },
    // beforeDestroy () {
    //     window.removeEventListener('scroll', this.onScroll);
    //}
}
</script>

<style scoped>
.appbar {
    background: var(--dark2);
    border-bottom: 3px solid var(--blue);
    z-index: 500;
    position: fixed;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex: 0 1 auto;
}
.appbar-items-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}
.appbar a {
    text-decoration: none;
    padding: 10px 15px;
    font-family: lato-light;
    transition: all 0.5s;
    color: white;
}
.appbar a:hover {
    background: var(--blue);
}
a.router-link-active {
    background: var(--blue);
}
.slide-enter-active {
    animation: slide-in 0.8s ease-in-out;
}
.slide-leave-active {
    animation: slide-in 0.3s reverse;
}
@keyframes slide-in {
    from {
        opacity: 0;
        top: -30px;
    }
    to {
        opacity: 1;
        top: 0px;
    }
}

@media (min-width: 1024px) {
    .appbar {
        justify-content: center;
    }
    .appbar-items-wrapper {
        width: var(--page-width);
        align-self: center;
    }
}
</style>